module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewer grid sm-column"
  }, [_c('div', {
    staticClass: "links cell md-5 lg-3"
  }, [_c('button', {
    staticClass: "btn md-hide lg-hide",
    on: {
      "click": function($event) {
        _vm.showMenu = !_vm.showMenu
      }
    }
  }, [_vm._v("=")]), _vm._v(" "), _c('ul', {
    class: {
      showMenu: _vm.showMenu
    }
  }, _vm._l((_vm.links), function(link) {
    return _c('li', [_c('router-link', {
      class: {
        active: _vm.isActiveLink(link)
      },
      attrs: {
        "to": _vm.makeLink(link)
      }
    }, [_vm._v("\n          " + _vm._s(link.name) + "\n        ")]), _vm._v(" "), (_vm.isActiveLink(link)) ? _c('ul', {
      staticClass: "sub-links"
    }, _vm._l((_vm.anchors), function(anchor) {
      return _c('li', [_c('a', {
        class: {
          active: _vm.isActiveHash(anchor)
        },
        attrs: {
          "href": _vm.makeHash(link, anchor)
        }
      }, [_vm._v("\n              " + _vm._s(anchor.name) + "\n            ")])])
    })) : _vm._e()], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "view cell sz",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    },
    on: {
      "scroll": _vm.onScroll
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-43f119a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewer.vue
// module id = 60
// module chunks = 0